'use client';

import { useFieldContext } from '@/lib/form';
import { Input } from '@sapling/ui/components/ui/input';
import { Label } from '@sapling/ui/components/ui/label';
import { FieldError, fieldErrorId } from './field-error';

export function TextField({
  label,
  placeholder,
  type = 'text',
  autoComplete,
  optional,
}: {
  label: string;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel';
  autoComplete?: string;
  optional?: boolean;
}) {
  const field = useFieldContext<string>();
  const hasErrors =
    field.state.meta.isTouched && field.state.meta.errors.length > 0;

  return (
    <div>
      <Label htmlFor={field.name}>
        {label}
        {optional ? (
          <span className="text-neutral-400"> (valfritt)</span>
        ) : (
          ' *'
        )}
      </Label>
      <Input
        id={field.name}
        type={type}
        value={field.state.value}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        placeholder={placeholder}
        autoComplete={autoComplete}
        aria-invalid={hasErrors}
        aria-describedby={hasErrors ? fieldErrorId(field.name) : undefined}
      />
      <FieldError errors={field.state.meta.errors} fieldName={field.name} />
    </div>
  );
}
